









































































































































import { resepStore } from "@/store/modules/resep";
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
// import CardListResep from "@/components/pemeriksaan/resep-obat/CardListResep.vue";
import CardListPenunjang from "@/components/kunjunganPasien/CardListPenunjang.vue";
import CardListRiwayatResep from "@/components/kunjunganPasien/CardListRiwayatResep.vue";
import http from "@/axios/http-common";
import { userModule } from "@/store/modules/user";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
import CardModalRiwayatPenunjang from "@/components/modal/CardModalRiwayatPenunjang.vue";
import { storePasien } from "@/store/modules/pasien";
import { storeSoap } from "@/store/modules/soap";

@Component({
  components: {
    CardListRiwayatResep,
    CardListPenunjang,
    CardModalRiwayatPenunjang
  }
})
export default class CardResepPenunjang extends Vue {
  title = "";
  type = "";
  showTitle = false;
  selectedItem = null;
  clearDetail = [];
  panel = [];
  modalListPenunjang = false;

  showList() {
    this.modalListPenunjang = true;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateSoap() {
    return storeSoap.soapAll;
  }

  // listResep = [];
  // activeResep = {};

  mounted() {
    // this.getResepList(this.register).then(() => {
    //   const userResep = resepStore.resep.filter((resep) => {
    //     return resep.dokter.id == userModule.user.id;
    //   });
    //   if (userResep.length) {
    //     this.setActiveResep(userResep[userResep.length - 1]);
    //   }
    // });
    // storePenunjang.act_hasil_lab_byTrans();
  }

  get listRo() {
    return storePenunjang.listhasilRadiologi;
  }
  get listPenunjangLain() {
    return storePenunjang.penunjanglain;
  }

  get listResep() {
    return storeResepFarmasi.listResepFarmasi;
  }
  get listLab() {
    return storePenunjang.listhasilLab;
  }
  get stateuser() {
    return userModule.user;
  }
  setTypeLab() {
    storePenunjang.clear_hasil_ro();

    this.title = "Laboratorium";
    this.type = "lab";
    // alert(this.type);
  }
  setTypeRo() {
    // storePenunjang.clear_hasil_ro();
    this.title = "Radiologi";
    this.type = "ro";
    // alert(this.type);
  }
  setTypeLain() {
    this.title = "Penunjang Lain";
    this.type = "lain";
  }
  detailHasil(val) {
    // console.log(val);
    // alert(val["tipe"]);
    if (val["tipe"] == "ro") {
      storePenunjang.clear_hasil_ro();
      storePenunjang.act_hasil_ro_byReg(val);
      // alert("RO");
    } else {
      // alert("LAB");
      // storePenunjang.act_hasil_lab_byTrans();
      // console.log("Hasil LAb");
    }
  }
  clearResep() {
    storeResepFarmasi.clear_detail_resepfarmasi();
    this.clearDetail = [];
    this.selectedItem = null;
  }
  viewPenunjangLain(url) {
    console.log("url", url);
    window.open(url, "_blank");
  }
}
